export const GLOBAL_DATE_FORMAT = "MM/dd/yyyy" as const;

export const DATE_EMPTY_VALUE = "—" as const;

/**
 * Describes how dates are displayed and parsed inside a text input.
 * Decouples DateInputFilter (and the three date utils) from any single locale or format.
 */
export interface DateFormatConfig {
    /** Human-readable label shown as the input placeholder, e.g. "MM/DD/YYYY". */
    displayLabel: string;
    /** Token for the foundation date formatter, e.g. "MM/dd/yyyy". */
    formatToken: string;
    /** Character that separates the three display fields, e.g. "/". */
    separator: string;
    /**
     * Width of each display field in digits, in the order they appear.
     * e.g. [2, 2, 4] for MM/DD/YYYY; [4, 2, 2] for YYYY-MM-DD.
     */
    slotSizes: readonly [number, number, number];
    /**
     * Which calendar field each display slot represents, in order.
     * e.g. ["month", "day", "year"] for MM/DD/YYYY.
     */
    partOrder: readonly ["year" | "month" | "day", "year" | "month" | "day", "year" | "month" | "day"];
}

/** Default format config: US MM/DD/YYYY, consistent with GLOBAL_DATE_FORMAT. */
export const TABLE_DATE_FORMAT_CONFIG: DateFormatConfig = {
    displayLabel: GLOBAL_DATE_FORMAT.toUpperCase(),
    formatToken: GLOBAL_DATE_FORMAT,
    separator: "/",
    slotSizes: [2, 2, 4],
    partOrder: ["month", "day", "year"],
} as const;
